import { getTravelHomeApiUrl } from '../selectors/selectors';

export default {
  fetch: (id, action, state) => ({
    url: `${getTravelHomeApiUrl(state)}/travel/home/v1/unusedCredit`,
    opts: {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        clientId: '684C957199C3BE6C153A778D1986032B',
      },
    },
  }),
  transformData: (data) => data.map((obj) => ({ ...obj, id: obj.accountToken })),
};
